import VerificationLayout from "../../components/verification/VerificationLayout.jsx"
import StatusBox from "../../components/verification/StatusBox.jsx"
import PatientDetails from "../../components/verification/PatientDetails.jsx"
import { useLocation } from "react-router-dom";




export default function MilestoneLogged() {
  const location = useLocation();
  const patientData = location.state?.patientData || {};
  const lastAction = location.state?.lastAction || {};

  return (
    <VerificationLayout title="Validation - Milestone logged">
      <StatusBox
        type="success"
        title="Milestone successfully logged"
        message={
          <>
            <p className="mb-4">
              The milestone has been successfully recorded.
              <br />
            </p>
            All relevant data has been timestamped and secured.
          </>
        }
      />

      <PatientDetails
        patient={patientData}
        lastAction={lastAction}
        showMultipleActions={true}
      />

      <div className="text-center text-lg ">
        <p>You may close this window</p>
      </div>
    </VerificationLayout>
  );
}